export enum Designer {
  printDesigner = 'printDesigner'
}
